import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/** Whether Supabase is configured at all in this build — false for any
 * environment that hasn't set VITE_SUPABASE_URL/VITE_SUPABASE_PUBLISHABLE_KEY
 * (a fresh `git clone`, CI, a Netlify deploy that predates this env var
 * being added). The rest of the app must keep working with Supabase
 * entirely absent, not just unauthenticated — this stays a fully
 * client-side/offline-capable app for anyone who never sets these. */
export const supabaseConfigured = Boolean(import.meta.env.VITE_SUPABASE_URL && import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY);

/** Null when unconfigured (see supabaseConfigured) — check that first,
 * rather than relying on every call site to null-check this individually. */
export const supabase: SupabaseClient | null = supabaseConfigured
  ? createClient(import.meta.env.VITE_SUPABASE_URL!, import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY!, {
      auth: {
        // PKCE (not the older implicit flow) returns the sign-in redirect's
        // one-time code in the URL's query string (?code=...), never its
        // hash fragment. This app's whole routing scheme IS the hash
        // fragment (#/performance, #/settings, ...) — an implicit-flow
        // redirect's #access_token=... would collide with it outright.
        flowType: 'pkce',
      },
    })
  : null;
